import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import {
  CUSTOMER_PROPERTY_NAVIGATION,
  CUSTOMER_PROPERTY_NAVIGATION_FACADE,
} from "../../lib/constants/navigation";
import DetailHeader from "../../components/details/DetailHeader";
import BreadcrumbNav from "../../components/common/BreadcrumbNav";
import { useSearchParams } from "react-router-dom";
import { useCustomerBuildingReports } from "../../utils/hooks/useCustomerBuildingReports";
import ReportTypeSwitcher from "../CustomerFlow/ReportTypeSwitcher";
import { getUserType } from "../../utils/authutils";
import LayoutContentContainer from "./LayoutContentContainer";
import { useSidebarContextStore } from "./sidebarStore";

const CustomerSecondaryLayout = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const reportType = searchParams.get("reportType");
  const buildingId = searchParams.get("buildingId");
  const userType = getUserType();
  const isClientUser = userType === "client" || userType === "client_member";

  const { data: overviewImages = [] } = useCustomerBuildingReports(
    isClientUser ? buildingId : null,
  );

  const showSwitcher = isClientUser && !!buildingId && overviewImages.length > 0;
  const projectId = searchParams.get("projectId");
  const getLastReport = useSidebarContextStore((s) => s.getLastReport);

  const handleSwitch = (newReportType, newOverviewImageId) => {
    const stored = getLastReport(buildingId, newReportType);

    if (stored) {
      const [path, query = ""] = stored.split("?");
      const qs = new URLSearchParams(query);
      qs.set("overviewImageId", newOverviewImageId);
      qs.set("reportType", newReportType);
      navigate(`${path}?${qs.toString()}`);
      return;
    }

    const newParams = new URLSearchParams();
    newParams.set("overviewImageId", newOverviewImageId);
    newParams.set("buildingId", buildingId || "");
    newParams.set("reportType", newReportType);
    newParams.set("step", "info");
    if (projectId) newParams.set("projectId", projectId);
    navigate(`/dashboard/building/information?${newParams.toString()}`);
  };
  const SidebarNav =
    reportType === "facade" ? CUSTOMER_PROPERTY_NAVIGATION_FACADE : CUSTOMER_PROPERTY_NAVIGATION;

  return (
    <div className="h-screen w-screen overflow-hidden flex flex-row bg-white">
      <Sidebar navigation={SidebarNav} />
      <LayoutContentContainer>
        <div className="sticky top-0 z-10 bg-white">
          <div className="mx-4">
            <DetailHeader hasBack={true} projectId={projectId}>
              {showSwitcher && (
                <ReportTypeSwitcher
                  overviewImages={overviewImages}
                  reportType={reportType || "roof"}
                  onSwitch={handleSwitch}
                />
              )}
            </DetailHeader>
          </div>
          <BreadcrumbNav />
        </div>
        <Outlet />
      </LayoutContentContainer>
    </div>
  );
};

export default CustomerSecondaryLayout;
